import { useState } from 'react';

function useLoginInfo() {
  const [loginData, setLoginData] = useState({});

  const addLoginData = () => {
    const login = window.digitalData && window.digitalData.login;
    window.digitalData.login = {
      ...window.digitalData.login,
      ...login,
    };
    setLoginData({ ...window.digitalData.login });
  };

  const isLoginDataEmpty = Object.keys(loginData).length === 0;

  return {
    addLoginData,
    loginData,
    isLoginDataEmpty,
  };
}

export { useLoginInfo };
